import { changePasswordPayloadToJSON } from '@/modules/profileModule/model/profile'

const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.EMPLOYEES)

export const apiChangePassword = {
	changePassword: async (employeeUUID: string, payload: IProfileChangePasswordPayload) => {
		await apiCommon(`${groupPrefix}/${employeeUUID}/password-update`, {
			method: 'PUT',
			body: changePasswordPayloadToJSON(payload),
		})
	},
}
